import React, { useRef } from 'react';
import './styles.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import icon1 from '../../assets/Icon 1.svg';
import icon2 from '../../assets/Icon 2.svg';
import icon3 from '../../assets/Icon 3.svg';
import icon4 from '../../assets/Icon 4.svg';
import icon5 from '../../assets/Icon 5.svg';
import icon6 from '../../assets/Icon 6.svg';
import { useGSAP } from '@gsap/react';
import './styles.css';

gsap.registerPlugin(ScrollTrigger);

const Features = ({ isMobile }) => {
  const cardsRef = useRef([]);

  useGSAP(() => {
    if (isMobile) {
      return;
    }
    gsap.set('.card-up', {
      left: '80',
    });

    gsap.from('.card-up', {
      left: '-150',
      ease: 'power1.inOut',
      scrollTrigger: {
        trigger: '.card-up',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });

  useGSAP(() => {
    if (isMobile) {
      return;
    }
    gsap.set('.card-down', {
      left: '-80',
    });

    gsap.from('.card-down', {
      left: '150',
      ease: 'power1.inOut',
      scrollTrigger: {
        trigger: '.card-down',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });

  const features = [
    {
      img: icon1,
      title: 'FLEXIBLE PLATFORM',
      description:
        'With this application you can do anything, you can use it for work, for fun, or you can just use it to better organize your applications.',
    },
    {
      img: icon2,
      title: 'FULLY SECURED',
      description:
        'Your data is saved in your Google Drive and on your own desktop, protected with cutting-edge encryption.',
    },
    {
      img: icon3,
      title: 'TIME SAVER',
      description:
        'Never waste time switching apps or switching accounts again, you can have all your apps and accounts in one place.',
    },
    {
      img: icon4,
      title: 'ORGANIZATION',
      description:
        'Have all your apps and accounts organized in one place with several preference options for each app.',
    },
    {
      img: icon5,
      title: 'EASY DEPLOY',
      description:
        'You can start using the app and get organized in less than 15 minutes.',
    },
    {
      img: icon6,
      title: 'MORE FOCUS',
      description:
        "Don't have distractions from your goals, just have what is important for you on your screen.",
    },
  ];

  return (
    <section
      id="features"
      className="py-16 bg-gradient-to-tl from-black to-gray-900 flex justify-center flex-col section"
    >
      <h1 className="text-center font-bold mb-32 text-white text-xl sm:text-3xl lg:text-4xl">
        All Your Data Needs in a Single Workspace
      </h1>
      <div className="card-div max-w-7xl mx-auto px-4">
        <div className="card-up gap-5 mb-5 w-3/4 md:w-full mx-auto grid md:grid-cols-3 grid-cols-1 md:gap-4 relative">
          {features.slice(0, 3).map((feature, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`card-${index + 1} ${
                !isMobile ? 'card' : ''
              } bg-gradient-to-br from-gray-800 to-gray-900 opacity-90 flex flex-col justify-center p-2 text-xl sm:p-6 lg:p-12 rounded-3xl hover:shadow-violet-900 shadow-violet-950 shadow-lg transition min-w-0`}
              style={{ height: 'auto' }}
            >
              <div className="mb-4 flex gap-2 items-center text-white">
                <img src={feature.img} alt="icon" className="h-12 w-12" />
                <h2 className="text-xs mt-2 mb-4 font-bold lg:text-xl">
                  {feature.title}
                </h2>
              </div>
              <p className="text-gray-400 text-base">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="card-down gap-5 w-3/4 md:w-full mx-auto grid md:grid-cols-3 grid-cols-1 md:gap-4 relative">
          {features.slice(3).map((feature, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`card-${index + 4} ${
                !isMobile ? 'card' : ''
              } bg-gradient-to-br from-gray-800 to-gray-900 opacity-90 flex flex-col justify-center p-2 text-xl sm:p-6 lg:p-12 rounded-3xl hover:shadow-violet-900 shadow-violet-950 shadow-lg transition min-w-0`}
              style={{ height: 'auto' }}
            >
              <div className="mb-4 flex gap-2 items-center text-white">
                <img src={feature.img} alt="icon" className="h-12 w-12" />
                <h2 className="text-xs mt-2 mb-4 font-bold sm:text-lg lg:text-xl">
                  {feature.title}
                </h2>
              </div>
              <p className="text-gray-400 text-base">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
